export default "__VITE_ASSET__6390ff4f__"